import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "../context/users/users";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const ProtectedRoute = ({ requiredPermission }) => {
  const { loggedin_user_detail } = useUserContext();
  const [hasPermission, setHasPermission] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const apiToken = localStorage.getItem("api_token");
    if (!apiToken) {
      setHasPermission(false);
      setIsLoading(false);
      return;
    }

    // Get account permissions from localStorage
    const accountPermissions = JSON.parse(localStorage.getItem("account_permissions") || "[]");
    // If user is admin, they have access to everything
    if (localStorage.getItem("is_admin") === "1") {
      setHasPermission(true);
    } 
    // Otherwise check if they have the required permission
    else if (requiredPermission && accountPermissions.includes(requiredPermission)) {
      setHasPermission(true);
    } else {
      setHasPermission(false);
    }
    
    setIsLoading(false);
  }, [loggedin_user_detail, requiredPermission]);

  if (isLoading) {
    return null; // Or a loading spinner
  }

  if (!hasPermission) {
    toast.error("You do not have permission to access this page");
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute; 